<template>
  <div :class="[`${direction}Input`]">
    <span v-if="name" id="inputTitle">
      {{ name }}
    </span>

    <b-form-textarea
      v-model="currentValue"
      :placeholder="placeholder"
      :rows="rows"
      :max-rows="maxRows"
      :size="size"
      :class="[`${styleType}Style`]"
      :no-resize="noresize"
      :plaintext="plaintext"
      :readonly="readonly"
      @input="onInput"
    />
  </div>
</template>

<script>
export default {
  name: 'TextArea',
  props: {
    name: {
      type: String,
      default: null
    },

    placeholder: {
      type: String,
      default: null
    },

    rows: {
      type: Number,
      default: 3
    },

    maxRows: {
      type: Number,
      default: null
    },

    styleType: {
      type: String,
      default: 'normal'
    },

    plaintext: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: 'sm'
    },

    value: {
      required: true,
      type: String,
      default: ''
    },

    noresize: {
      type: Boolean,
      default: true
    },

    readonly: {
      type: Boolean,
      default: false
    },

    direction: {
      type: String,
      default: 'vertical'
    }
  },

  data() {
    return {
      currentValue: this.value
    }
  },

  methods: {
    onInput() {
      this.$emit('input', this.currentValue)
    }
  }
}
</script>

<style lang="scss" scoped>
$text-color: #8b69a9;
$border-color: #8b69a9;

#inputTitle {
  margin-right: 10px;
}

/*direction styling*/

.verticalInput {
  margin-bottom: 15px;
}

.horizontalInput {
  display: grid;
  grid-template-columns: 30% 30%;
  margin-left: 5%;
  margin-bottom: 15px;
}

/*textArea styling*/

.normalStyle {
  border-radius: 10px;
  border: 2px $border-color solid;
}

.tableStyle {
  line-break: anywhere;
  white-space: pre-wrap;
}
</style>
